export default "__VITE_ASSET__34546f36__"